module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/kaoawase-plan-og-image-58a9c24215e377a561a69149ce1d9b92.png";